import api from "../api/axios";

import { getAuthHeaders, requestWithRefresh } from "../Utils/apiUtils";
import {
  UpdateClusterPayload,
  CreateClusterPayload,
} from "../Types/CompanyProfile/Cluster";

export const CLUSTER_QUERY_KEY = ["cluster"];
export const VIEW_CLUSTER_QUERY_KEY = ["view-clustere"];

export const clusterService = {
  createCluster: async (payload: CreateClusterPayload) => {
    const response = await api.post(`api/cluster`, payload);
    return response.data;
  },
  updateCluster: async (id: number, payload: UpdateClusterPayload) => {
    const response = await api.patch(`api/cluster/${id}`, payload);
    return response.data;
  },
  toggleStatus: async (id: number) =>
    requestWithRefresh(() =>
      api
        .patch(`api/cluster/${id}/toggle-status`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data),
    ),
  getAllViewClusterByCompany: async (company_code: string) =>
    requestWithRefresh(() =>
      api
        .get(`api/view-cluster?company_code=${company_code}`, {
          headers: getAuthHeaders(),
        })
        .then((res) => res.data.data),
    ),
  getAllViewClusterByCompanyAndRegion: async (
    company_code: string,
    region_id: number,
  ) =>
    requestWithRefresh(() =>
      api
        .get(
          `api/view-cluster?company_code=${company_code}&&region_id=${region_id}`,
          {
            headers: getAuthHeaders(),
          },
        )
        .then((res) => res.data.data),
    ),
  getClusterById: async (id: number) =>
    requestWithRefresh(() =>
      api
        .get(`api/cluster/${id}`, { headers: getAuthHeaders() })
        .then((res) => res.data.data),
    ),
};
